import styled from "styled-components";

export const New = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-width: 264px;
  cursor: pointer;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(-3px);
  }
`;

export const NewImage = styled.img`
  height: 200px;
  width: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;

  ${New}:hover & {
    transform: scale(1.05);
  }
`;

export const NewTheme = styled.span`
  text-transform: uppercase;
  color: var(--primary);
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.5px;
  margin: 0 20px;
`;

export const NewTitle = styled.span`
  line-height: 28px;
  font-weight: 600;
  font-size: 0.75rem;
  color: var(--neutral);
  margin: 0 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.3s ease;

  ${New}:hover & {
    color: var(--primary);
  }
`;

export const NewDescription = styled.span`
  color: var(--neutral-light);
  font-size: 0.75rem;
  line-height: 22px;
  margin: 0 20px 20px 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
